/**
 * Sets the cursor position in an input DOM element
 * @param {number}      cursorPosition
 * @param {HTMLElement} inputElement
 */
function setPosition(cursorPosition, inputElement) {
    if (inputElement === document.activeElement) {
        if (inputElement.createTextRange) {
            const range = inputElement.createTextRange()
            range.move('character', cursorPosition)
            range.select()
        } else {
            inputElement.setSelectionRange(cursorPosition, cursorPosition)
        }
    }
}

/**
 * Call this function to find a new position for the cursor. This function is only necessary if you are
 * formatting the input's value in real-time (while the user is typing). When you add or remove content
 * from the input, the standard position might not reflect the natural position of the cursor. That is
 * when you need this.
 *
 * @param {string}      oldValue     - the previous value of the input (could already have changed)
 * @param {string}      newValue     - the expected new value of the input (eg. after formatting it)
 * @param {HTMLElement} inputElement
 * @returns {number}
 */
function findPosition(oldValue, newValue, inputElement) {
    const cursorPosition = inputElement ? inputElement.selectionEnd : 0
    if (!newValue || newValue.length === 0) {
        return 0
    }
    if (newValue && cursorPosition === newValue.length) {
        return cursorPosition
    }

    let i = 0
    const currentIndex = string => string.length - 1 - i
    const currentValue = string => string[currentIndex(string)]
    while (i <= oldValue.length && currentValue(newValue) && currentValue(oldValue)) {
        if (currentValue(oldValue) !== currentValue(newValue)) {
            break
        }
        i = i + 1
    }
    const newCursorPosition = currentIndex(newValue) + 1

    if (newCursorPosition < cursorPosition) {
        return cursorPosition
    }
    const increase = oldValue && newValue && newValue.length > oldValue.length
    if (increase && cursorPosition === newCursorPosition) {
        return cursorPosition + (newValue.length - oldValue.length - 1)
    }

    return newCursorPosition
}

const Cursor = {
    findPosition,
    setPosition
}
export default Cursor
